import {inject} from '@angular/core';
import {CanMatchFn} from '@angular/router';
import {AuthController} from '@core/auth/auth.controller';
export const AuthGuard: CanMatchFn = async () => {
  const auth = inject(AuthController);
  await auth.verify();
  return auth.operationalStatus() == 'ACTIVE';

};
